// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-column-stacked';

export const Component = () => (
  <path d='M1 0v21h21v1H0V0h1Zm11.5 10v9H9v-9h3.5Zm6-2v11H15V8h3.5Zm-12 6v5H3v-5h3.5Zm0-4v2H3v-2h3.5Zm6-4v2H9V6h3.5Zm-6 1v1H3V7h3.5Zm12-2v1H15V5h3.5Zm-6-3v2H9V2h3.5Z' />
);

export const viewBox = '0 0 22 22';
